import * as sentry from "@sentry/react";

const trackGTagAnalytics = (
  eventName: string,
  data: Record<string, unknown> = {},
) => {
  try {
    if (
      typeof window !== "undefined" &&
      typeof (window as any).gtag === "function"
    ) {
      (window as any).gtag("event", eventName, data);
    } else {
      console.warn("Google Analytics is not available.");
    }
  } catch (e) {
    console.warn(`Error in trackGTagAnalytics: ${eventName}`, e);
    sentry.captureException(e);
  }
};

export default trackGTagAnalytics;
